import fetch from "utils/fetch";

export function getData(id, query) {
  return fetch({
    url: `/api/blogger/postManage/${id}`,
    method: "get",
    params: query
  });
}

export function getDataByPostId(authorId, postId) {
    return fetch({
      url: `/api/blogger/postManage/${authorId}/detail/${postId}`,
      method: "get",
    });
  }

export function getOptionsPost(authorId,keyWord) {
    return fetch({
      url: `/api/blogger/options/post`,
      method: "get",
      banLoading:true,
      params: {
        authorId,
        keyWord
      }
    });
  }

  export function getOptionsLocation(keyWord) {
    return fetch({
      url: `/api/blogger/options/loaction`,
      method: "get",
      banLoading:true,
      params: {
        keyWord
      }
    });
  }

  export function getOptionsTag(keyWord) {
    return fetch({
      url: `/api/blogger/options/tag`,
      method: "get",
      banLoading:true,
      params: {
        keyWord
      }
    });
  }

  export function getOptionsSubType() {
    return fetch({
      url: `/api/blogger/options/subType`,
      method: "get",
    });
  }

  export function postData(authorId,query) {
    return fetch({
      url: `/api/blogger/postManage/${authorId}`,
      method: "post",
      data:query,
      message:'Add Success'
    });
  }

  export function postImg(authorId,postId,query) {
    return fetch({
      url: `/api/blogger/postManage/${authorId}/image/${postId}`,
      method: "post",
      data:query,
      message:'upload Success'
    });
  }

  export function deletePost(authorId,postId,query) {
    return fetch({
      url: `/api/blogger/postManage/${authorId}/delete/${postId}`,
      method: "post",
      params:query,
      message:'Delete Success'
    });
  }

  export function putPost(authorId,query) {
    return fetch({
      url: `/api/blogger/postManage/${authorId}`,
      method: "put",
      data:query
    });
  }

  export function postDeprecatedPost(authorId,postId) {
    return fetch({
      url: `/api/blogger/postManage/${authorId}/cancellation/${postId}`,
      method: "post",
    });
  }


// WEBPACK FOOTER //
// ./src/api/post/post.js